import classNames from 'classnames';
import React from 'react';

type StatsAndStreakType = 'INSIGHT' | 'EMOTION_WHEEL' | 'MINDFUL' | 'STREAK';
type ColorType = 'INSIGHT' | 'EMOTION_WHEEL' | 'MINDFUL';

const cardConfigs = {
  MINDFUL: {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" viewBox="0 0 22 25" fill="none">
        <path
          d="M11.0001 23.86C16.4787 23.86 20.9201 19.4187 20.9201 13.94C20.9201 8.46133 16.4787 4.02 11.0001 4.02C5.52141 4.02 1.08008 8.46133 1.08008 13.94C1.08008 19.4187 5.52141 23.86 11.0001 23.86Z"
          stroke="#010101"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M11 1.74V4.02" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.1394 1.14H9.85938" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11 7.86V14.17" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.0293 16.47L10.9993 14.17" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  INSIGHT: {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none">
        <path d="M7.87988 0.501343V3.67134" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.540039 1.4314L2.79004 3.67139" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.4597 1.4314L13.2197 3.67139" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.87988 20.3414V17.1714" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.540039 19.4114L2.79004 17.1714" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15.4597 19.4114L13.2197 17.1714" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M8.00004 14.8813C12.1201 14.8813 15.46 12.9427 15.46 10.5513C15.46 8.15991 12.1201 6.22131 8.00004 6.22131C3.87999 6.22131 0.540039 8.15991 0.540039 10.5513C0.540039 12.9427 3.87999 14.8813 8.00004 14.8813Z"
          stroke="#231F20"
          strokeMiterlimit="10"
        />
        <path
          d="M7.87992 11.6213C8.54819 11.6213 9.08992 11.0796 9.08992 10.4113C9.08992 9.74303 8.54819 9.20129 7.87992 9.20129C7.21166 9.20129 6.66992 9.74303 6.66992 10.4113C6.66992 11.0796 7.21166 11.6213 7.87992 11.6213Z"
          stroke="#231F20"
          strokeMiterlimit="10"
        />
      </svg>
    ),
  },
  EMOTION_WHEEL: {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
        <path
          d="M10.5001 20.42C15.9787 20.42 20.4201 15.9787 20.4201 10.5C20.4201 5.02134 15.9787 0.580002 10.5001 0.580002C5.02141 0.580002 0.580078 5.02134 0.580078 10.5C0.580078 15.9787 5.02141 20.42 10.5001 20.42Z"
          stroke="#010101"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M0.580078 10.5H20.4201" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.0502 3.37L3.49023 16.93" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.0293 0.970001V20.3" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.7207 4.07L17.0507 17.4" stroke="#010101" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  STREAK: {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
        <path
          d="M9.82422 0.501343H3.82422C3.82422 0.501343 4.30422 5.17134 4.30422 5.89134C4.30422 8.11134 7.86422 8.43134 7.86422 13.1813H11.7842C11.7842 8.43134 15.3442 8.11134 15.3442 5.89134C15.3442 5.18134 15.8242 0.501343 15.8242 0.501343H9.82422Z"
          stroke="#231F20"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8949 13.5913H6.79492V16.4213H12.8949V13.5913Z"
          stroke="#231F20"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5243 16.4214H5.1543V20.3414H14.5243V16.4214Z"
          stroke="#231F20"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.82453 1.4613C3.82453 1.4613 2.07453 1.0713 1.41453 1.4613C0.234528 2.1613 0.314528 4.0613 4.30453 5.8913"
          stroke="#231F20"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.1743 1.76135C16.1743 1.76135 17.9243 1.37135 18.5843 1.76135C19.7643 2.46135 19.6843 4.36135 15.6943 6.19135"
          stroke="#231F20"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
};

const colorConfigs = {
  INSIGHT: 'bg-[#CFF6D8]',
  EMOTION_WHEEL: 'bg-[#FCE1CB]',
  MINDFUL: 'bg-[#F4E5F4]',
};

interface StatsAndStreakProps {
  type: StatsAndStreakType;
  color: ColorType;
  value: number;
  unit: string;
  title: string;
}

interface StatsAndStreakContainerProps {
  children: React.ReactNode;
  className?: string;
}

const StatsAndStreak: React.FC<StatsAndStreakProps> = ({ type, color, value, unit, title }) => {
  const config = cardConfigs[type];
  const backgroundColor = colorConfigs[color];

  return (
    <div
      className={`flex items-center justify-center rounded-xl p-4 ${backgroundColor} min-w-[170px] border-2 border-white`}>
      <div className="mr-4 flex flex-col items-center justify-center">
        <div>{config.icon}</div>
        <p className="mt-sh-5 text-sh-11-14 font-semibold text-gray-800">{title}</p>
      </div>

      <div className="flex flex-col items-center justify-center">
        <div className="text-sh-28-28">{value}</div>
        <p className="mt-sh-5 text-sh-11-14 font-semibold text-gray-800">{unit}</p>
      </div>
    </div>
  );
};

export const StatsAndStreakContainer: React.FC<StatsAndStreakContainerProps> = ({ children, className }) => (
  <div className={classNames('flex justify-center gap-4', className)}>{children}</div>
);

export default StatsAndStreak;
